import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { NgClass, NgForOf, NgIf } from '@angular/common'

@Component({
  selector: 'app-pagination',
  standalone: true,
    imports: [
        NgForOf,
        NgClass,
        NgIf
    ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit, OnChanges {

    @Input() currentPage: number = 0
    @Input() totalPages: number = 1
    @Output() onPageChange = new EventEmitter<number>()

    pages: number[]
    showEllipsisStart: boolean = false
    showEllipsisEnd: boolean = false

    ngOnInit() {
        this.setupPages()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['totalPages'] && changes['totalPages'].currentValue !== changes['totalPages'].previousValue) {
            this.setupPages()
        }
        if (changes['currentPage'] && changes['currentPage'].currentValue !== changes['currentPage'].previousValue) {
            this.setupPages()
        }
    }

    setupPages() {
        if (this.totalPages <= 1) {
            this.pages = [0];
            this.currentPage = 0;
            this.totalPages = 1;
            this.showEllipsisStart = false;
            this.showEllipsisEnd = false;
            return;
        }

        this.generateCompactPagination();
    }

    generateCompactPagination() {
        this.pages = [];
        this.showEllipsisStart = false;
        this.showEllipsisEnd = false;
        
        // If 7 or fewer pages, show all pages
        if (this.totalPages <= 7) {
            for (let i = 0; i < this.totalPages; i++) {
                this.pages.push(i);
            }
            return;
        }
        
        // Always show first page
        this.pages.push(0);
        
        // Calculate visible pages around current page
        const currentPageIndex = this.currentPage;
        
        // If current page is close to the start
        if (currentPageIndex < 3) {
            // Show pages 1, 2, 3, 4
            for (let i = 1; i < 4; i++) {
                this.pages.push(i);
            }
            this.showEllipsisEnd = true;
        } 
        // If current page is close to the end
        else if (currentPageIndex >= this.totalPages - 3) {
            this.showEllipsisStart = true;
            // Show last 4 pages (excluding the very last one which is added below)
            for (let i = this.totalPages - 4; i < this.totalPages - 1; i++) {
                this.pages.push(i);
            }
        } 
        // If current page is in the middle
        else {
            this.showEllipsisStart = true;
            // Show one page before current
            this.pages.push(currentPageIndex - 1);
            // Show current page
            this.pages.push(currentPageIndex);
            // Show one page after current
            this.pages.push(currentPageIndex + 1);
            this.showEllipsisEnd = true;
        }
        
        // Always show last page
        this.pages.push(this.totalPages - 1);
    }

    onPageChangeHandler(pageNumber: number) {
        if(this.currentPage !== pageNumber && pageNumber >= 0 && pageNumber <= this.totalPages - 1){
            this.currentPage = pageNumber;
            this.onPageChange.emit(pageNumber)
        }
    }
}
